import { supabase } from '../lib/supabaseClient';

export async function fetchShowRecommendations(website_id) {
  const { data: show, error: showError } = await supabase
    .from('shows')
    .select('id')
    .eq('website_id', website_id)
    .single();

  if (showError || !show) {
    console.error("Show fetch error:", showError);
    return [];
  }

  // Step 2: Paginate episode fetching
  let episodes = [];
  const batchSize = 1000;
  let from = 0;
  let to = batchSize - 1;
  let moreEpisodes = true;

  while (moreEpisodes) {
    const { data: batch, error } = await supabase
      .from('episodes')
      .select('id, name, date')
      .eq('show_id', show.id)
      .range(from, to);

    if (error) {
      console.error("Episode fetch error:", error);
      break;
    }

    if (batch.length === 0) {
      moreEpisodes = false;
    } else {
      episodes = episodes.concat(batch);
      from += batchSize;
      to += batchSize;
    }
  }

  console.log("📦 Total episodes fetched:", episodes.length);

  const episodeMap = Object.fromEntries(
    episodes.map((ep) => [ep.id, { name: ep.name, date: ep.date }])
  );

  const episodeIds = episodes.map((ep) => ep.id);
  const chunkSize = 100;
  let allRecs = [];

  // Step 3: Fetch recs in chunks to avoid .in() limits
  for (let i = 0; i < episodeIds.length; i += chunkSize) {
    const chunk = episodeIds.slice(i, i + chunkSize);

    const { data: recsChunk, error: recsError } = await supabase
      .from('recommendations')
      .select('*')
      .in('episode_id', chunk);

    if (recsError) {
      console.error(`Recommendations fetch error for chunk ${i}-${i + chunkSize}:`, recsError);
      continue;
    }

    if (recsChunk) {
      allRecs = allRecs.concat(recsChunk);
    }
  }

  console.log("✅ Recommendations fetched:", allRecs.length);

  return allRecs
    .map((rec, index) => {
      const episode = episodeMap[rec.episode_id] || {};
      return {
        id: `rec${index}`,
        fields: {
          id: rec.id,
          Title: episode.name || "",
          Link: rec.url || null,
          Recommendation: rec.name || "",
          Date: episode.date || "",
          ImageUrl: rec.image_url || "",
          Category: rec.category ? rec.category.split(",").map(c => c.trim()) : [],
          Recommender: rec.recommender ? rec.recommender.split(",").map(r => r.trim()) : [],
        }
      };
    })
    .sort((a, b) => new Date(b.fields.Date) - new Date(a.fields.Date));
}
